// use this method
document.addEventListener('crJQActivated', function (e) { 

	jqCR('body').on('click', '[name="checkout"]', function(e){

    if (jqCR('#pickup-details').length) {
   		e.preventDefault();
 
      var myForm = jqCR('#pickup-details').closest('form')
	    
	    var pickupFirstName = '';
	    var pickupLastName = '';
	    
	  	var shippingInformation = storePickup.shippingInformation + 'test'
	    //storePickup.updateFormActionWithShippingInformation();
	    
	    var action = myForm.attr('action');      	      
	    if (action == '/cart') {
        action = '/checkout?'      	
      }
	    var pivot = action.replace(/checkout\\[shipping_address\\]\\[first_name\\](.*?)\\&/ig, '');
	  	shippingInformation = pivot + "&checkout[shipping_address][first_name]=" + pickupFirstName;
	  	
	    pivot = shippingInformation.replace(/checkout\\[shipping_address\\]\\[last_name\\](.*?)\\&/ig, '');      	
	    shippingInformation = pivot + "&checkout[shipping_address][last_name]=" + pickupLastName + '&';
        
        pivot = shippingInformation.replace(/checkout\\[shipping_address\\]\\[city\\](.*?)\\&/ig, '');      	
	    shippingInformation = pivot + "&checkout[shipping_address][city]=" + pickupLastName + '&';
        
        pivot = shippingInformation.replace(/checkout\\[shipping_address\\]\\[province\\](.*?)\\&/ig, '');      	
	    shippingInformation = pivot + "&checkout[shipping_address][province]=" + pickupLastName + '&';
        
        pivot = shippingInformation.replace(/checkout\\[shipping_address\\]\\[address1\\](.*?)\\&/ig, '');      	
	    shippingInformation = pivot + "&checkout[shipping_address][address1]=" + pickupLastName + '&';
        
        pivot = shippingInformation.replace(/checkout\\[shipping_address\\]\\[phone\\](.*?)\\&/ig, '');      	
	    shippingInformation = pivot + "&checkout[shipping_address][phone]=" + pickupLastName + '&';
        
        pivot = shippingInformation.replace(/checkout\\[shipping_address\\]\\[zip\\](.*?)\\&/ig, '');      	
	    shippingInformation = pivot + "&checkout[shipping_address][zip]=" + pickupLastName + '&';
        
        pivot = shippingInformation.replace(/checkout\\[shipping_address\\]\\[company\\](.*?)\\&/ig, '');      	
	    shippingInformation = pivot + "&checkout[shipping_address][company]=" + pickupLastName + '&';
	  
	  	myForm.attr('action', shippingInformation)  
	  

        if (myForm.valid()) {
          myForm.submit()      	
        }
      }else{
      
      }
  })
})